/** @file useProjectName: a project's name from the server for the top bar (its id until known). */
import { useEffect, useState } from 'react';
import type { EditorApi } from '../store/editorApi';

/** `api.projects.get(id).name`; the id while loading, on failure, without a server, or for a null id (empty). */
export function useProjectName(api: EditorApi | null, projectId: string | null): string {
  const [name, setName] = useState<{ id: string; name: string } | null>(null);
  useEffect(() => {
    if (api === null || projectId === null) return undefined;
    let live = true;
    api.projects.get(projectId).then((p) => { if (live) setName({ id: projectId, name: p.name }); }, () => undefined);
    return () => { live = false; };
  }, [api, projectId]);
  if (projectId === null) return '';
  return name?.id === projectId ? name.name : projectId;
}
